import React from 'react';
import { Loader2 } from 'lucide-react';

const RenewableMapLoadingOverlay = ({ message }) => (
  <div
    className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center"
    style={{ zIndex: 1000 }}
  >
    <div className="text-center">
      <Loader2 className="h-8 w-8 animate-spin text-indigo-500 mx-auto mb-2" />
      <div className="text-sm text-gray-600">{message}</div>
    </div>
  </div>
);

export default RenewableMapLoadingOverlay;
